export default __webpack_public_path__ + "static/media/plan.a9a5a698.svg";